module.exports = __webpack_public_path__ + "static/media/school-bus.a502c62c.mov";